import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import WgptBotEvalRecommendationsAPI from '../../api/wgpt/botEvalRecommendations';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getRecommendations($state) {
    return $state.records;
  },
  getRecommendation: $state => id => {
    return $state.records.find(record => record.id === Number(id)) ?? {};
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, { botId, status } = {}) => {
    commit(types.SET_WGPT_BOT_EVAL_RECOMMENDATIONS_UI_FLAG, {
      isFetching: true,
    });
    try {
      const params = {};
      if (status) params.status = status;
      const { data } = await new WgptBotEvalRecommendationsAPI(botId).get(
        params
      );
      commit(types.SET_WGPT_BOT_EVAL_RECOMMENDATIONS, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_EVAL_RECOMMENDATIONS_UI_FLAG, {
        isFetching: false,
      });
    }
    return null;
  },
  update: async ({ commit }, { botId, id, ...updateObj }) => {
    commit(types.SET_WGPT_BOT_EVAL_RECOMMENDATIONS_UI_FLAG, {
      isUpdating: true,
    });
    try {
      const { data } = await new WgptBotEvalRecommendationsAPI(botId).update(
        id,
        updateObj
      );
      commit(types.EDIT_WGPT_BOT_EVAL_RECOMMENDATION, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_EVAL_RECOMMENDATIONS_UI_FLAG, {
        isUpdating: false,
      });
    }
    return null;
  },
};

export const mutations = {
  [types.SET_WGPT_BOT_EVAL_RECOMMENDATIONS_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_WGPT_BOT_EVAL_RECOMMENDATIONS]: MutationHelpers.set,
  [types.EDIT_WGPT_BOT_EVAL_RECOMMENDATION]: MutationHelpers.update,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
